// extracted by mini-css-extract-plugin
export default {"link":"link_link__nX9Fv","underline":"link_underline__Ks7rz"};